/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchActivityGetInternal} from '../api'

export const useMutationBatchActivityGetInternal = createReactQueryMutationHook('batchActivityGetInternal', batchActivityGetInternal)
